// removed by extract-text-webpack-plugin
module.exports = {"floatingFilter":"_2J0o2","floatingButtonFilter":"_1HYlQ","floatingFilterDrawer":"_2YXot","open":"_3MBiZ","closed":"ojD_9","floatingFilterDrawerHeader":"_2aVGb","closeIcon":"_6uExO","floatingFilterDrawerBody":"_3dS2Y","floatingFilterDrawerFooter":"_2jt4R","clearButton":"_3zFML","applyButton":"_1YfHP"};


//////////////////
// WEBPACK FOOTER
// ./src/views/v2/search/components/filter/components/floatingStyles.module.css
// module id = 236
// module chunks = 0